




















































import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';
import util from '@/components/util';

export default Vue.extend({
  name: 'Signup',
  components: {
    ...util,
    VariableInput,
  },
  props: {
    error : Object,
    isPhone: Boolean,
  },
  data() {
    return {
      showModal: false,
      accountData: new models.CAuth(),
      items: [
        {key: 'mail', name: 'メールアドレス', type: vi.INPUT_TYPE.TEXT, placeholder: 'メールアドレス', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', max: 40 },
        {key: 'password', name: 'パスワード', type: vi.INPUT_TYPE.PASSWORD, placeholder: 'パスワード', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
        // {key: 'passwordConfirm', name: 'パスワード(確認用)', type: vi.INPUT_TYPE.PASSWORD, placeholder: 'パスワード確認用', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
      ] as vi.IVariableInput[],
      dispToggleInputs: [
        'password',
        // 'passwordConfirm',
      ],
      dispToggles: {
        password: 'password',
        // passwordConfirm: 'password',
      },
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  watch: {
    error: {
      deep: true,
      handler(newValue: any) {
        const target = this.items.filter((v) => (v.key === newValue.key));
        target[0].error = newValue.error;
      },
    },
  },
  mounted() {
    document.getElementsByClassName('carousel-control-next')[0].removeAttribute('href');
    document.getElementsByClassName('carousel-control-prev')[0].removeAttribute('href');
    if (process.env.VUE_APP_MODE === 'PROD') {
      (this as any).$gtm.trackView( location.pathname.toString() , location.toString());
    }
  },
  methods: {
    onClickSignUp() {
      // vallidation check
      if (vi.checkValues(this.accountData, this.items) > 0) {
        return;
      }
      // フリーメール対策
      if (['@gmail.' , '@hotmail.' , '@yahoo.'].filter((v) => (this.accountData.mail.indexOf(v) > -1 )).length > 0) {
        this.items[0].error = 'フリーメールはご利用できません';
        return;
      }
      const validPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,40}$/;
      // パスワードが確認と一致しない場合
      // if (this.accountData.password !== this.accountData.passwordConfirm) {
      //   this.items[2].error = 'パスワードが一致しません';
      //   return;
      // } else
      if (!validPassword.test(this.accountData.password)) {
        this.items[1].error = '半角大小英数字を1文字ずつ含む8文字以上40字以内';
        return;
      }
      this.$emit('signup', this.accountData);
    },
    toLogin() {
      this.$emit('change', 'login');
    },
    dispToggle(input: string) {
      const el = document.querySelector('#' + input + '-input input') as any;

      if (el.type === 'text') {
        el.type = 'password';
      } else {
        el.type = 'text';
      }
    },
    toLink() {
      window.open('https://remolabo.net/service/pricing/', '_blank');
    },
  },
});
